import React from 'react'

import LabelCard from '../LabelCard'
import { getScaleForMinGlyphMm } from '../labelGlyphScale'

const getCardType = (number) =>
  number % 2 === 0 ? 'back' : 'front'

export default function MultiFabricLabels({
  data: { washingLabel },
}) {
  const fabricItems =
    washingLabel?.[0]?.fabric ?? []

  /*
   * Page2'de 3 numaralı kart hazır olduğu için
   * MultiFabric 4 numaradan başlar.
   *
   * 3 = front
   * 4 = back
   * 5 = front
   * 6 = back
   */
  let currentNumber = 4

  const cards = []

  const renderLabelCards = (item, itemIndex) => {
    if (!item) return

    const mixItems = Array.isArray(item.mix)
      ? item.mix
      : []

    let currentCardContents = []
    let currentCardLength = 0

    const addCard = () => {
      if (currentCardContents.length === 0) {
        return
      }

      const number = currentNumber
      const cardContents = [
        ...currentCardContents,
      ]

      cards.push(
        <LabelCard
          key={`fabric-card-${itemIndex}-${number}`}
          className="pdf-force text-[5.7pt] leading-[5.7pt] px-[2.5mm]"
          number={number}
          type={getCardType(number)}
        >
          <div className="flex flex-col items-center justify-center h-full pt-1 -mt-[4px]">
            {cardContents.map(
              (content, contentIndex) => {
                const normalizedContent =
                  String(content ?? '')

                const percentSeparatorIndex =
                  normalizedContent.indexOf('%')

                const hasPercent =
                  percentSeparatorIndex !== -1

                const percent = hasPercent
                  ? normalizedContent.slice(
                      0,
                      percentSeparatorIndex
                    )
                  : normalizedContent

                const text = hasPercent
                  ? normalizedContent.slice(
                      percentSeparatorIndex + 1
                    )
                  : ''

                /*
                 * Yüzde içermeyen değer kumaş başlığıdır.
                 * Örneğin item.text.
                 */
                const isFabric = !hasPercent

                const lineText = isFabric
                  ? percent
                  : `${percent}%${text}`

                const dynamicScaleY =
                  getScaleForMinGlyphMm(
                    lineText,
                    {
                      font: '5.7pt PdfSafe',
                      minMm: 2,
                      baseScale: 1.2,
                      maxScale: 4,
                      glyphCase: isFabric
                        ? 'lower'
                        : 'upper',
                    }
                  )

                return (
                  <div
                    key={`fabric-content-${number}-${contentIndex}`}
                    className="flex items-center gap-x-[2px] text-justify mt-[10px]"
                    style={{
                      transform: `scaleY(${dynamicScaleY})`,
                      fontFamily: 'PdfSafe',
                    }}
                  >
                    <div
                      className={
                        !isFabric &&
                        percent.length <= 3
                          ? 'w-[42px]'
                          : ''
                      }
                    >
                      {isFabric
                        ? percent
                        : `${percent}%`}
                    </div>

                    {!isFabric && (
                      <div>{text}</div>
                    )}
                  </div>
                )
              }
            )}
          </div>
        </LabelCard>
      )

      /*
       * Kart oluşturulduktan sonra
       * sıradaki numaraya geç.
       */
      currentNumber += 1

      currentCardContents = []
      currentCardLength = 0
    }

    /*
     * Ana kumaş metni.
     */
    const itemText = String(
      item?.text ?? ''
    ).trim()

    if (
      itemText.length > 0 &&
      itemText.length <= 350
    ) {
      currentCardContents.push(itemText)
      currentCardLength += itemText.length
    }

    /*
     * Kumaş karışımları.
     */
    mixItems.forEach((mix) => {
      const mixText = String(
        mix?.text ?? ''
      ).trim()

      const mixPercent =
        mix?.percent ?? ''

      if (
        !mixText ||
        mixPercent === '' ||
        mixPercent === null ||
        mixPercent === undefined
      ) {
        return
      }

      const completeMixText =
        `${mixPercent}% ${mixText}`

      if (
        currentCardLength +
          mixText.length <=
        550
      ) {
        currentCardContents.push(
          completeMixText
        )

        currentCardLength +=
          mixText.length
      } else {
        /*
         * Mevcut kart dolduysa önce onu ekle,
         * ardından yeni karta devam et.
         */
        addCard()

        currentCardContents.push(
          completeMixText
        )

        currentCardLength =
          mixText.length
      }
    })

    /*
     * Kalan içerikleri son karta ekle.
     */
    addCard()
  }

  fabricItems.forEach(
    (item, itemIndex) => {
      renderLabelCards(item, itemIndex)
    }
  )

  return {
    cards,

    /*
     * Son kullanılan numara değil,
     * sıradaki kullanılabilir numara.
     *
     * Örneğin son kart 6 ise
     * lastNumber 7 döner.
     */
    lastNumber: currentNumber,
  }
}